		const mockStores = [
		  // ... (39 สาขาก่อนหน้า) ...
		

		{
			group: 'BEAUTRIUM',
			name: 'Seacon Bangkae',
			province: 'Bangkok',
			tel: '080-935-8917',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'Room 135, 1st Floor, Seacon Bangkae, 607 Phet Kasem Rd, Bang Wa, Phasi Charoen, Bangkok 10160'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Seacon Square Srinakarin',
			province: 'Bangkok',
			tel: '080-935-9781',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 55, Room 1107AB-1108A, G Floor, Srinagarindra Rd, Nong Bon, Prawet, Bangkok 10250'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Siam Square',
			province: 'Bangkok',
			tel: '080-935-9973',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 240/9, Flagship Building (formerly Now26), Soi Siam Square 7, Rama I Rd, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Pinklao',
			province: 'Bangkok',
			tel: '080-936-0173',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 7/222, Borommaratchachonnani Rd, Arun Amarin, Bangkok Noi, Bangkok 10700'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Pattaya Beach',
			province: 'Chon Buri',
			tel: '090-949-7883',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 333/99, Moo 9, Central Pattaya Building, Room G33-G36, G Floor, Nong Prue, Bang Lamung, Chon Buri 20150'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Rayong',
			province: 'Rayong',
			tel: '080-936-0913',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 99, 99/1, Central Rayong, 1st Floor, Room 145-148, Bang Na-Trat Rd, Choeng Noen, Mueang Rayong, Rayong 21000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Khon Kaen',
			province: 'Khon Kaen',
			tel: '064-586-0809',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 99, 99/1, Central Khon Kaen, 1st Floor, Room 114-117/2, Si Chan Rd, Nai Mueang, Mueang Khon Kaen, Khon Kaen 40000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Si Racha',
			province: 'Chon Buri',
			tel: '080-935-9927',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 8, Central Si Racha, G Floor, Room G 01/3, Sukhumvit Rd, Si Racha, Chon Buri 20110'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Ayutthaya',
			province: 'Phra Nakhon Si Ayutthaya',
			tel: '063-880-7368',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 129/1-3, Central Ayutthaya, G Floor, Room G47-G49, Sai Asia Rd, Khlong Suan Phlu, Phra Nakhon Si Ayutthaya 13000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Udon Thani',
			province: 'Udon Thani',
			tel: '063-880-7457',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 277/1-3, 271/5, Central Udon Thani, Room A240, 2nd Floor, Prajak Sillapakom Rd, Mak Khaeng, Mueang Udon Thani, Udon Thani 41000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Chanthaburi',
			province: 'Chanthaburi',
			tel: '096-091-1346',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 199, Moo 7, Central Chanthaburi, Room G04-G06, G Floor, Chanthanimit, Mueang Chanthaburi, Chanthaburi 22000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Surat Thani',
			province: 'Surat Thani',
			tel: '064-504-9755',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 88, Moo 10, Central Surat Thani, Room 117-118, 1st Floor, Wat Pradu, Mueang Surat Thani, Surat Thani 84000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Rama 9',
			province: 'Bangkok',
			tel: '080-242-7332',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 9/9, Central Plaza Grand Rama 9, Room 209-210, 2nd Floor, Rama 9 Rd, Huai Khwang, Bangkok 10310'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Thalang',
			province: 'Phuket',
			tel: '080-242-7550',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 8/88, Moo 5, Robinson Lifestyle Thalang, Room RTL-1F-RR-NEW, 1st Floor, Si Sunthon, Thalang, Phuket 83110'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Ratchaphruek',
			province: 'Nonthaburi',
			tel: '065-805-8488',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 19/11, Moo 4, Robinson Lifestyle Ratchaphruek, Room RRP-1F-RR-NEW, 1st Floor, Khlong Khoi, Pak Kret, Nonthaburi 11120'
		},
		{
			group: 'BEAUTRIUM',
			name: 'ICS (Mixed-Use Lifestyle Town)',
			province: 'Bangkok',
			tel: '063-918-7882',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 168, ICS Building, Room M05, M Floor, Charoen Nakhon Rd, Khlong Ton Sai, Khlong San, Bangkok 10600'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Future Park Rangsit',
			province: 'Pathum Thani',
			tel: '090-949-7885',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 94, Future Park Rangsit, Room SHP040B-041A-B, 1st Floor, Phahonyothin Rd, Prachatipat, Thanyaburi, Pathum Thani 12130'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Ladprao',
			province: 'Bangkok',
			tel: '099-659-9581',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 1697, Central Ladprao, Room 208, 2nd Floor, Phahonyothin Rd, Chatuchak, Bangkok 10900'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Suphan Buri',
			province: 'Suphan Buri',
			tel: '097-167-3421',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 449, Moo 5, Robinson Suphan Buri, Room RSP-1F-RR-165, 1st Floor, Tha Rahat, Mueang Suphan Buri, Suphan Buri 72000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Korat',
			province: 'Nakhon Ratchasima',
			tel: '063-906-8381',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 990, 998, Central Korat, Room 161, 175, 1st Floor, Mittraphap-Nong Khai Rd, Nai Mueang, Mueang Nakhon Ratchasima, Nakhon Ratchasima 30000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Westville',
			province: 'Nonthaburi',
			tel: '063-862-9897',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 999, Moo 5, Central Westville, Room 103, 1st Floor, Maha Sawat, Bang Kruai, Nonthaburi 11130'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central World',
			province: 'Bangkok',
			tel: '082-949-9690',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 4, 4/1-4/2, 4/4, Central World, Room B214/2, B215, 2nd Floor, Ratchadamri Rd, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Phitsanulok',
			province: 'Phitsanulok',
			tel: '063-851-1564',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 9/99, Moo 5, Central Phitsanulok, Room 274-276, 2nd Floor, Phlai Chumphon, Mueang Phitsanulok, Phitsanulok 65000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Nakhon Sawan',
			province: 'Nakhon Sawan',
			tel: '063-819-2428',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 699, Moo 10, Central Nakhon Sawan, Room G36-G38, G Floor, Nakhon Sawan Tok, Mueang Nakhon Sawan, Nakhon Sawan 60000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Market Village Hua Hin',
			province: 'Prachuap Khiri Khan',
			tel: '063-851-7944',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 234/1, Market Village Hua Hin, Room S105, S107, 1st Floor, Phet Kasem Rd, Hua Hin, Prachuap Khiri Khan 77110'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Nakhon Pathom',
			province: 'Nakhon Pathom',
			tel: '064-656-8335',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 833, Central Nakhon Pathom, Room G21, G22, G Floor, Phet Kasem Rd, Sanam Chan, Mueang Nakhon Pathom, Nakhon Pathom 73000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Trang',
			province: 'Trang',
			tel: '065-853-2234',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 138, Robinson Trang, Room RTR-1F-RR-151, 1st Floor, Phatthalung Rd, Thap Thiang, Mueang Trang, Trang 92000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Asawann Nong Khai',
			province: 'Nong Khai',
			tel: '063-940-3359',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 304, Moo 10, Asawann Shopping Complex 1, Room A-23, 1st Floor, Pho Chai, Mueang Nong Khai, Nong Khai 43000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Market Village Suvarnabhumi',
			province: 'Samut Prakan',
			tel: '065-846-2234',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 99/29, Moo 1, Market Village Suvarnabhumi, Room S105-106, 1st Floor, Racha Thewa, Bang Phli, Samut Prakan 10540'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Asiatique The Riverfront',
			province: 'Bangkok',
			tel: '063-885-5755',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 2194, Asiatique The Riverfront, Room 402, 1st Floor, Warehouse 4 (Building J), Charoen Krung Rd, Wat Phraya Krai, Bang Kho Laem, Bangkok 10120'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Lotus Yala',
			province: 'Yala',
			tel: '064-586-6005',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 23, Lotus Yala, Room PG004, 1st Floor, Thesabal 1 Rd, Sateng, Mueang Yala, Yala 95000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Ocean Chumphon',
			province: 'Chumphon',
			tel: '064-164-1496',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 188/111, Ocean Shopping Mall Chumphon, Room F-127, 1st Floor, Sala Daeng Rd, Tha Taphao, Mueang Chumphon, Chumphon 86000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Mahachai',
			province: 'Samut Sakhon',
			tel: '064-164-1429',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 98, Moo 4, Central Mahachai, Room 115-117, 1st Floor, Na Di, Mueang Samut Sakhon, Samut Sakhon 74000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Coliseum Yala',
			province: 'Yala',
			tel: '064-164-2414',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 505, Coliseum Yala, Room G12, 1st Floor, Siroros Rd, Sateng, Mueang Yala, Yala 95000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Samui',
			province: 'Surat Thani',
			tel: '064-164-1497',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 209, 209/1-209/2, Moo 2, Central Samui, Room 146/1, 1st Floor, Bo Phut, Ko Samui, Surat Thani 84320'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Lotus Sam Kong Phuket',
			province: 'Phuket',
			tel: '088-983-6411',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 104, Moo 5, Lotus Phuket, Room PG019, 1st Floor, Chalermphrakiat Ratchakan Thi 9 Rd, Ratsada, Mueang Phuket, Phuket 83000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Bowin',
			province: 'Chon Buri',
			tel: '088-983-6311',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 354, Moo 6, Robinson Lifestyle Bowin, Room RBW-1F-RR-101/2, 1st Floor, Bowin, Si Racha, Chon Buri 20230'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Diana Complex Pattani',
			province: 'Pattani',
			tel: '088-983-6233',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 16, Diana Complex Pattani, Room RF67PTN/061270/0001, G Floor, Na Klua Rd, Anoru, Mueang Pattani, Pattani 94000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Ban Chang',
			province: 'Rayong',
			tel: '088-983-6199',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 162, Moo 6, Robinson Lifestyle Ban Chang, Room RBC-1FRR-119-123/1,2, 1st Floor, Ban Chang, Rayong 21130'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Makro Sathorn',
			province: 'Bangkok',
			tel: '064-158-4566',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 1, Makro Sathorn (CP Axtra), Room PG001, 1st Floor, Naradhiwas Rajanagarindra Rd, Thung Wat Don, Sathon, Bangkok 10120'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Makro Sri Ayutthaya',
			province: 'Bangkok',
			tel: '083-946-3393',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 565, Makro Sri Ayutthaya (CP Axtra), Room PG008, 1st Floor, Sri Ayutthaya Rd, Thanon Phaya Thai, Ratchathewi, Bangkok 10400'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Marina',
			province: 'Chon Buri',
			tel: '095-364-1953',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 78/54, Moo 9, Central Marina, Room 144-147, 1st Floor, Pattaya Sai 2 Rd, Nong Prue, Bang Lamung, Chon Buri 20260'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Lotus Saraburi',
			province: 'Saraburi',
			tel: '095-364-1903',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 91/3, Lotus Saraburi, Room PG553, 1st Floor, Mittraphap Rd, Pak Phriao, Mueang Saraburi, Saraburi 18000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Avenue Pattaya',
			province: 'Chon Buri',
			tel: '084-223-4893',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 179/214, Moo 5, Avenue Pattaya, Room B-106, B-107, 1st Floor, Na Klua, Bang Lamung, Chon Buri 20150'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Lampang',
			province: 'Lampang',
			tel: '084-223-6148',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 319, Central Lampang, Room 125, 1st Floor, Highway Lampang-Ngao Rd, Suan Dok, Mueang Lampang, Lampang 52100'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Central Chiang Mai Airport',
			province: 'Chiang Mai',
			tel: '084-223-6825',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 9, 9/1, Moo 3, Central Chiang Mai Airport, Room 133-135, 1st Floor, Suthep, Mueang Chiang Mai, Chiang Mai 50200'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Surin',
			province: 'Surin',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 338, Moo 16, Robinson Lifestyle Surin, Room 101, 1st Floor, Salak Dai, Mueang Surin, Surin 32000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Phetchaburi',
			province: 'Phetchaburi',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 162, Moo 1, Robinson Lifestyle Phetchaburi, Room 110/1-110/2, 1st Floor, Samo Phlue, Ban Lat, Phetchaburi 76150'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Mega Bangna',
			province: 'Samut Prakan',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 39, Moo 6, Mega Bangna, Room 1446, 1st Floor, Bangna-Trad Rd, Bang Kaeo, Bang Phli, Samut Prakan 10540'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Lotus Bowin',
			province: 'Chon Buri',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 117/46, Moo 3, Lotus Bowin, Room PG504, 1st Floor, Bowin, Si Racha, Chon Buri 20230'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Srisaman',
			province: 'Nonthaburi',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 99, Moo 1, Robinson Lifestyle Srisaman, Room 154/1, 1st Floor, Ban Mai, Pak Kret, Nonthaburi 11120'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Lotus Nakhon Si Thammarat',
			province: 'Nakhon Si Thammarat',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 15, Lotus Nakhon Si Thammarat, Room PG557, 1st Floor, Phatthanakan Khu Khwang Rd, Nai Mueang, Mueang Nakhon Si Thammarat, Nakhon Si Thammarat 80000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Buri Ram',
			province: 'Buri Ram',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 125, Moo 6, Robinson Lifestyle Buri Ram, Room 115, 1st Floor, Krasang, Mueang Buri Ram, Buri Ram 31000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Robinson Lifestyle Kanchanaburi',
			province: 'Kanchanaburi',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 110, 110/2, Moo 9, Robinson Lifestyle Kanchanaburi, Room 163, 1st Floor, Pak Phraek, Mueang Kanchanaburi, Kanchanaburi 71000'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Lotus Ban Bueng',
			province: 'Chon Buri',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 64, Lotus Ban Bueng, Room PG005, 1st Floor, Ban Bueng-Ban Khai Rd, Ban Bueng, Chon Buri 20170'
		},
		{
			group: 'BEAUTRIUM',
			name: 'Big C Nakhon Pathom',
			province: 'Nakhon Pathom',
			tel: '',
			url: 'https://www.facebook.com/BEAUTRIUM?locale=th_TH',
			address: 'No. 754, Big C Supercenter Nakhon Pathom, Room GCR142, G Floor, Phet Kasem Rd, Huai Chorakhe, Mueang Nakhon Pathom, Nakhon Pathom 73000'
		},
		{
			group: 'TSURUHA',
			name: 'Gateway Ekamai',
			province: 'Bangkok',
			tel: '02-108-2850, 085-675-8120',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'Gateway Ekamai, Room M123-M124, M Floor, No. 982/22 Sukhumvit Rd, Phra Khanong, Khlong Toei, Bangkok'
		},
		{
			group: 'TSURUHA',
			name: 'J-Park (Waseda)',
			province: 'Chon Buri',
			tel: '038-339-864, 081-375-6270',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'No. 9/4, Moo 6, Surasak, Si Racha, Chon Buri 20230'
		},
		{
			group: 'TSURUHA',
			name: 'Yada (Silom)',
			province: 'Bangkok',
			tel: '02-236-2681, 099-759-4665',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'Yada Building, Room 103, No. 56 Silom Rd, Suriyawong, Bang Rak, Bangkok 10500'
		},
		{
			group: 'TSURUHA',
			name: 'Siam Square',
			province: 'Bangkok',
			tel: '092-225-9916',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'No. 430/45-46 Rama I Rd, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'TSURUHA',
			name: 'Fashion Island',
			province: 'Bangkok',
			tel: '092-225-9864',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'No. 587, 589, 589/7-9 Room 2074B-2075, 2nd Floor, Ram Inthra Rd, Khan Na Yao, Bangkok 10230'
		},
		{
			group: 'TSURUHA',
			name: 'Lasalle Avenue',
			province: 'Bangkok',
			tel: '092-225-4047',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'Lasalle Avenue, Room B003-B006, No. 549, 549/1 Lasalle-Bearing Rd, Bangna Tai, Bang Na, Bangkok 10260'
		},
		{
			group: 'TSURUHA',
			name: 'Avenue Pattaya',
			province: 'Chon Buri',
			tel: '094-555-6234',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: 'Room B102-B105, 1st-2nd Floor, No. 179/120 Moo 5, Na Klua, Bang Lamung, Chon Buri 20150'
		},
		{
			group: 'TSURUHA',
			name: 'TSURUHA Online',
			province: 'All Provinces',
			tel: '',
			url: 'https://www.facebook.com/Tsuruhadrugstorethailand?locale=th_TH',
			address: ''
		},
		{
			group: 'WATSONS',
			name: 'WATSONS Online',
			province: 'All Provinces',
			tel: '',
			url: 'https://www.watsons.co.th/th/',
			address: ''
		},
		{
			group: 'LOTUS',
			name: 'Bang Yai',
			province: 'Nonthaburi',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 90, Moo 5, Bang Khu Wiang, Bang Kruai, Nonthaburi 11130'
		},
		{
			group: 'LOTUS',
			name: 'Pathum Thani',
			province: 'Pathum Thani',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 21/49 Pathum Sam Khok Rd, Bang Parok, Mueang Pathum Thani, Pathum Thani 12000'
		},
		{
			group: 'LOTUS',
			name: 'Rama 3',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 172 Naradhiwas Rajanagarindra Rd, Chong Nonsi, Yan Nawa, Bangkok 10120'
		},
		{
			group: 'LOTUS',
			name: 'Rangsit Khlong 7',
			province: 'Pathum Thani',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 41/2, Moo 2, Rangsit-Nakhon Nayok Rd, Lam Phak Kut, Thanyaburi, Pathum Thani 12110'
		},
		{
			group: 'LOTUS',
			name: 'Ram Inthra',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 59 Pradit Manutham Rd, Lat Phrao, Bangkok 10230'
		},
		{
			group: 'LOTUS',
			name: 'Sukhaphiban 3',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 101, 101/1 Ramkhamhaeng Rd, Min Buri, Bangkok 10510'
		},
		{
			group: 'LOTUS',
			name: 'Rattanathibet',
			province: 'Nonthaburi',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 245 Tiwanon Rd, Bang Krasor, Mueang Nonthaburi, Nonthaburi 11000'
		},
		{
			group: 'LOTUS',
			name: 'Sukhaphiban 1',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 1629 Nawamin Rd, Nuan Chan, Bueng Kum, Bangkok 10230'
		},
		{
			group: 'LOTUS',
			name: 'Nakhon Nayok',
			province: 'Nakhon Nayok',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. Kor.1–150 Ban Yai Rd, Ban Yai, Mueang Nakhon Nayok, Nakhon Nayok 26000'
		},
		{
			group: 'LOTUS',
			name: 'Phitsanulok',
			province: 'Phitsanulok',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 909, Moo 10, Phitsanulok-Lomsak Rd, Aranyik, Mueang Phitsanulok, Phitsanulok 65000'
		},
		{
			group: 'LOTUS',
			name: 'Saraburi',
			province: 'Saraburi',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 91/3 Mittraphap Rd, Pak Phriao, Mueang Saraburi, Saraburi 18000'
		},
		{
			group: 'LOTUS',
			name: 'Suphan Buri',
			province: 'Suphan Buri',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 293, Moo 5, Tha Rahat, Mueang Suphan Buri, Suphan Buri 72000'
		},
		{
			group: 'LOTUS',
			name: 'Phetchabun',
			province: 'Phetchabun',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 929, Moo 2, Sadiang, Mueang Phetchabun, Phetchabun 67000'
		},
		{
			group: 'LOTUS',
			name: 'Ban Bueng',
			province: 'Chon Buri',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 64 Ban Bueng-Ban Khai Rd, Ban Bueng, Chon Buri 20170'
		},
		{
			group: 'LOTUS',
			name: 'Khon Kaen 2',
			province: 'Khon Kaen',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 709, Moo 3, Sila, Mueang Khon Kaen, Khon Kaen 40000'
		},
		{
			group: 'LOTUS',
			name: 'Pak Chong',
			province: 'Nakhon Ratchasima',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 289, Moo 18, Pak Chong, Nakhon Ratchasima 30130'
		},
				// --- LOTUS GROUP ---
		{
			group: 'LOTUS',
			name: 'Nong Khai',
			province: 'Nong Khai',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 304, Moo 10, Mittraphap Rd, Pho Chai, Mueang Nong Khai, Nong Khai 43000'
		},
		{
			group: 'LOTUS',
			name: 'Udon Thani',
			province: 'Udon Thani',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 499/117, Soi Ban Non Phibun, Moo 7, Mak Khaeng, Mueang Udon Thani, Udon Thani 41000'
		},
		{
			group: 'LOTUS',
			name: 'Kanchanaburi',
			province: 'Kanchanaburi',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '1st Floor, No. 355/3, Sang Chuto Tai Rd, Pak Phraek, Mueang Kanchanaburi, Kanchanaburi 71000'
		},
		{
			group: 'LOTUS',
			name: 'Krabi',
			province: 'Krabi',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 191, Moo 12, Krabi Noi, Mueang Krabi, Krabi 81000'
		},
		{
			group: 'LOTUS',
			name: 'Nakhon Si Thammarat',
			province: 'Nakhon Si Thammarat',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 15, Phatthanakan Khu Khwang Rd, Nai Mueang, Mueang Nakhon Si Thammarat, Nakhon Si Thammarat 80000'
		},
		{
			group: 'LOTUS',
			name: 'Phatthalung',
			province: 'Phatthalung',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 155, Moo 2, Khao Chiak, Mueang Phatthalung, Phatthalung 93000'
		},
		{
			group: 'LOTUS',
			name: 'Songkhla',
			province: 'Songkhla',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 64, Moo 2, Khao Rup Chang, Mueang Songkhla, Songkhla 90000'
		},
		{
			group: 'LOTUS',
			name: 'Hat Yai',
			province: 'Songkhla',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: '2nd Floor, No. 1142, Kanjanavanich Rd, Hat Yai, Songkhla 90110'
		},
		{
			group: 'LOTUS',
			name: 'Hat Yai 2',
			province: 'Songkhla',
			tel: '',
			url: 'https://www.lotuss.com/th',
			address: 'No. 1318, Phet Kasem Rd, Hat Yai, Songkhla 90110'
		},

		// --- MULTY BEAUTY GROUP ---
		{
			group: 'MULTY',
			name: 'Seacon Square',
			province: 'Bangkok',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'Seacon Square, Room 2018-19, 2nd Floor, No. 55 Srinakarin Rd, Nong Bon, Prawet, Bangkok 10250'
		},
		{
			group: 'MULTY',
			name: 'Future Park Rangsit',
			province: 'Pathum Thani',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'No. 94, Phahonyothin Rd, Prachatipat, Thanyaburi, Pathum Thani 12130'
		},
		{
			group: 'MULTY',
			name: 'Mega Bangna',
			province: 'Samut Prakan',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'No. 39, Moo 6, Bangna-Trad Rd, Bang Kaeo, Bang Phli, Samut Prakan 10540'
		},
		{
			group: 'MULTY',
			name: 'Fashion Island',
			province: 'Bangkok',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'Fashion Island, Room 2070-72, 2nd Floor, No. 587, 589 Ram Inthra Rd, Khan Na Yao, Bangkok 10230'
		},
		{
			group: 'MULTY',
			name: 'Union Mall',
			province: 'Bangkok',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'Union Mall, Room 2L-02-08, F-2 Floor, No. 54, Soi Lat Phrao 1, Lat Phrao Rd, Chom Phon, Chatuchak, Bangkok 10900'
		},
		{
			group: 'MULTY',
			name: 'Multy Online',
			province: 'Bangkok',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'No. 58, Soi Charoen Rat 7, Junction 29-1, Bang Khlo, Bang Kho Laem, Bangkok 10120'
		},
		{
			group: 'MULTY',
			name: 'The Mall Bangkae',
			province: 'Bangkok',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'The Mall Bangkae, M Floor, Room M24, No. 518, 518/1 Phet Kasem Rd, Bang Khae Nuea, Bang Khae, Bangkok 10160'
		},
		{
			group: 'MULTY',
			name: 'Siam Square',
			province: 'Bangkok',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'No. 458, 458/1-5, Room Lock 28, Siam Square Soi 8, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'MULTY',
			name: 'Imperial World Samrong',
			province: 'Samut Prakan',
			tel: '089-492-1639',
			url: 'https://www.multybeauty.com/',
			address: 'Imperial World Samrong, Room SH-I-1071, 1F Floor, No. 999, Moo 1, Sukhumvit Rd, Samrong Nuea, Mueang Samut Prakan, Samut Prakan 10270'
		},

		// --- EVEANDBOY GROUP ---
		{
			group: 'EVEANDBOY',
			name: 'Khon Kaen (Kangsadan)',
			province: 'Khon Kaen',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 140/483, 552, Moo 14, Nai Mueang, Mueang Khon Kaen, Khon Kaen 40000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Terminal 21 Korat',
			province: 'Nakhon Ratchasima',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 99, Terminal 21 Korat, Nai Mueang, Mueang Nakhon Ratchasima, Nakhon Ratchasima 30000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Siam Square One',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 388, Siam Square One, Room FSLG008, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'EVEANDBOY',
			name: 'Future Park Rangsit',
			province: 'Pathum Thani',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 94, Future Park Rangsit, Prachatipat, Thanyaburi, Pathum Thani 12130'
		},
		{
			group: 'EVEANDBOY',
			name: 'Mega Bangna',
			province: 'Samut Prakan',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 39, Mega Bangna, Room 1472, 1474, Bang Kaeo, Bang Phli, Samut Prakan 10540'
		},
		{
			group: 'EVEANDBOY',
			name: 'The Mall Bangkapi',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 3522, The Mall Bangkapi, Room STM-03, M Floor, Lat Phrao Rd, Khlong Chan, Bang Kapi, Bangkok 10240'
		},
		{
			group: 'EVEANDBOY',
			name: 'The Mall Bangkae',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 518, 518/1, The Mall Bangkae, Room GT-G01, G Floor, Phet Kasem Rd, Bang Khae Nuea, Bang Khae, Bangkok 10160'
		},
		{
			group: 'EVEANDBOY',
			name: 'Fashion Island',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 587, 589, 589/7-9, Fashion Island, Khan Na Yao, Bangkok 10230'
		},
		{
			group: 'EVEANDBOY',
			name: 'Terminal 21 Asok',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 88, Terminal 21 Asok, Room SH-3-008, Khlong Toei Nuea, Watthana, Bangkok 10110'
		},
		{
			group: 'EVEANDBOY',
			name: 'EVEANDBOY Online',
			province: 'Samut Prakan',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 333/55, Moo 6, Bang Pla, Bang Phli, Samut Prakan 10540'
		},
		{
			group: 'EVEANDBOY',
			name: 'Siam Premium Outlets',
			province: 'Samut Prakan',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 989, Moo 14, Room G18, G Floor, Siam Premium Outlets, Bang Sao Thong, Samut Prakan 10570'
		},
		{
			group: 'EVEANDBOY',
			name: 'Samyan Mitrtown',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 944/1, Room 1I001-1I008, 1st Floor, Samyan Mitrtown, Rama 4 Rd, Wang Mai, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'EVEANDBOY',
			name: 'The Mall Ngamwongwan',
			province: 'Nonthaburi',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Room 221, 2nd Floor, The Mall Ngamwongwan, Ngamwongwan Rd, Bang Khen, Mueang Nonthaburi, Nonthaburi 11000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Maya Chiang Mai',
			province: 'Chiang Mai',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 55, 55/5, Room 212-214, Moo 5, Maya Chiang Mai, Super Highway Rd, Chang Phueak, Mueang Chiang Mai, Chiang Mai 50300'
		},
		{
			group: 'EVEANDBOY',
			name: 'Terminal 21 Pattaya',
			province: 'Chon Buri',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 777, Room G019-G022, Moo 6, Terminal 21 Pattaya, Na Klua, Bang Lamung, Chon Buri 20150'
		},
		{
			group: 'EVEANDBOY',
			name: 'The Mall Lifestore Thapra',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 99, The Mall Thapra, Room 105, 1st Floor, Ratchadaphisek Rd, Bukkhalo, Thon Buri, Bangkok 10600'
		},
		{
			group: 'EVEANDBOY',
			name: 'MBK Center',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 444, 1st Floor, MBK Center, Room PLA.F01.C36000, Phaya Thai Rd, Wang Mai, Bangkok 10330'
		},
		{
			group: 'EVEANDBOY',
			name: 'Seacon Square',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 55, Seacon Square, Room 2087, 2nd Floor, Srinakarin Rd, Nong Bon, Prawet, Bangkok 10250'
		},
		{
			group: 'EVEANDBOY',
			name: 'Terminal 21 Rama 3',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 356, Terminal 21 Rama 3, Room G046-G047, G Floor, Rama 3 Rd, Bang Khlo, Bang Kho Laem, Bangkok 10120'
		},
		{
			group: 'EVEANDBOY',
			name: 'Platinum Fashion Mall',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Novotel Bangkok Platinum Building, 1st Floor, No. 220 Phetchaburi Rd, Thanon Phetchaburi, Ratchathewi, Bangkok 10400'
		},
		{
			group: 'EVEANDBOY',
			name: 'UD Town Udon Thani',
			province: 'Udon Thani',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 45/5, UD Town, Room D1-D6, Thong Yai Rd, Mak Khaeng, Udon Thani 41000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Imperial World Samrong',
			province: 'Samut Prakan',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Imperial World Samrong, Room SH-I-1-016/1, 1st Floor, No. 999, Moo 1, Sukhumvit Rd, Samrong Nuea, Mueang Samut Prakan, Samut Prakan 10270'
		},
		{
			group: 'EVEANDBOY',
			name: 'Passione Shopping Destination',
			province: 'Rayong',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Passione Shopping Destination, Room PZ1-041, 1st Floor, No. 554 Sukhumvit Rd, Noen Phra, Mueang Rayong, Rayong 21000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Ayutthaya City Park',
			province: 'Ayutthaya',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Ayutthaya City Park, Room I-01, 2nd Floor, No. 126, Moo 3, Asia Rd, Khlong Suan Phlu, Phra Nakhon Si Ayutthaya, Ayutthaya 13000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Big C Rajdamri',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Big C Supercenter Rajdamri, Room GCR 112/2, G Floor, No. 97/11 Ratchadamri Rd, Lumphini, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'EVEANDBOY',
			name: 'Sermthai Complex Mahasarakham',
			province: 'Mahasarakham',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Sermthai Complex, Room R 148, 1st Floor, No. 76/1-7 Nakhon Sawan Rd, Talat, Mueang Mahasarakham, Mahasarakham 44000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Charn at the Avenue',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Building A, Charn at the Avenue, Room A110, 1st Floor, No. 104/42, Moo 1, Chaeng Watthana Rd, Thung Song Hong, Laksi, Bangkok 10210'
		},
		{
			group: 'EVEANDBOY',
			name: 'Hat Yai Village',
			province: 'Songkhla',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Building U, Room U 101/1, 1st Floor, No. 538/4 Kanjanavanich Rd, Hat Yai, Songkhla 90110'
		},
		{
			group: 'EVEANDBOY',
			name: 'The Street Ratchada',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'The Street Ratchada, Room 111, 1st Floor, No. 139 Ratchadaphisek Rd, Din Daeng, Bangkok 10400'
		},
		{
			group: 'EVEANDBOY',
			name: 'Centerpoint of Siam Square',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Centerpoint of Siam Square, Room 108, 1st-3rd Floor, No. 292 Rama I Rd, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'EVEANDBOY',
			name: 'Union Mall',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Union Mall, Room 2O-01, F-2 Floor, No. 54, Soi Lat Phrao 1, Chom Phon, Chatuchak, Bangkok 10900'
		},
		{
			group: 'EVEANDBOY',
			name: 'TU Dome Pathum Thani',
			province: 'Pathum Thani',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'TU Dome Residential Complex, Room A1-01, 1st Floor, No. 98/16, Moo 18, Chiang Rak Rd, Khlong Nueng, Khlong Luang, Pathum Thani 12120'
		},
		{
			group: 'EVEANDBOY',
			name: 'Major Cineplex Pinklao',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Major Cineplex Pinklao, Room G5, G Floor, No. 554/1 Borommaratchachonnani Rd, Bang Bamru, Bang Phlat, Bangkok 10700'
		},
		{
			group: 'EVEANDBOY',
			name: 'Sahathai Garden Plaza Surat Thani',
			province: 'Surat Thani',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Sahathai Garden Plaza, Room 226, 2nd Floor, No. 528/1 Talat Mai Rd, Talat, Mueang Surat Thani, Surat Thani 84000'
		},
		{
			group: 'EVEANDBOY',
			name: 'The Mall Korat',
			province: 'Nakhon Ratchasima',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'The Mall Korat, 1st Floor, No. 1242/2 Mittraphap Rd, Nai Mueang, Mueang Nakhon Ratchasima, Nakhon Ratchasima 30000'
		},
		{
			group: 'EVEANDBOY',
			name: 'V-Square Plaza Nakhon Sawan',
			province: 'Nakhon Sawan',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'V-Square Plaza, Room 208-210, 2nd Floor, No. 320/11 Sawan Withee Rd, Pak Nam Pho, Mueang Nakhon Sawan, Nakhon Sawan 60000'
		},
		{
			group: 'EVEANDBOY',
			name: 'True Digital Park',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: '101 True Digital Park, Room 109, 1st Floor, No. 101 Sukhumvit Rd, Bang Chak, Phra Khanong, Bangkok 10260'
		},
		{
			group: 'EVEANDBOY',
			name: 'PARC BANGNA',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'PARC BANGNA, Room B101, B201, 1st Floor, No. 955 Debaratna Rd, Bang Na Nuea, Bang Na, Bangkok 10260'
		},
		{
			group: 'EVEANDBOY',
			name: 'Paradise Park',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Paradise Park, 1st Floor, No. 61 Srinakarin Rd, Nong Bon, Prawet, Bangkok 10250'
		},
		{
			group: 'EVEANDBOY',
			name: 'Makkasan',
			province: 'Bangkok',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'No. 1199, Room Shop01-01, 1st Floor, New Phetchaburi Rd, Makkasan, Ratchathewi, Bangkok 10400'
		},
		{
			group: 'EVEANDBOY',
			name: 'Fairy Plaza Khon Kaen',
			province: 'Khon Kaen',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Fairy Plaza, 1st Floor, No. 69/9 Klang Mueang Rd, Nai Mueang, Mueang Khon Kaen, Khon Kaen 40000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Sunee Tower Ubon Ratchathani',
			province: 'Ubon Ratchathani',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Room Shop 134, 1st Floor, No. 512/8 Chayangkun Rd, Nai Mueang, Mueang Ubon Ratchathani, Ubon Ratchathani 34000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Pantip Lifestyle Hub Chiang Mai',
			province: 'Chiang Mai',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Room 107, 1st Floor, No. 152/1 Chang Khlan Rd, Chang Khlan, Mueang Chiang Mai, Chiang Mai 50100'
		},
		{
			group: 'EVEANDBOY',
			name: 'Sahathai Plaza Nakhon Si Thammarat',
			province: 'Nakhon Si Thammarat',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Sahathai Plaza Nakhon Si Thammarat, Room F1-18, 1st Floor, No. 1392 Sri Prat Rd, Tha Wang, Mueang Nakhon Si Thammarat, Nakhon Si Thammarat 80000'
		},
		{
			group: 'EVEANDBOY',
			name: 'Bluport Hua Hin',
			province: 'Prachuap Khiri Khan',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Bluport Hua Hin, Room G11, G Floor, No. 8/89, Soi Muban Nong Kae, Nong Kae, Hua Hin, Prachuap Khiri Khan 77110'
		},
		{
			group: 'EVEANDBOY',
			name: 'Ocean Complex Chumphon',
			province: 'Chumphon',
			tel: '02-022-4888',
			url: 'https://www.eveandboy.com/',
			address: 'Ocean Complex, Room A41-A07, 1st Floor, No. 58 Krom Luang Chumphon Rd, Tha Taphao, Mueang Chumphon, Chumphon 86000'
		},

		// --- KIS BEAUTY STORE GROUP ---
		{
			group: 'KIS',
			name: 'Central World',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 4, 4/5 Ratchadamri Rd, Pathum Wan, Bangkok 10330'
		},
		{
			group: 'KIS',
			name: 'Central Mega Bangna',
			province: 'Samut Prakan',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 39, Moo 6, Bang Kaeo, Bang Phli, Samut Prakan 10540'
		},
		{
			group: 'KIS',
			name: 'Central Khon Kaen',
			province: 'Khon Kaen',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 99/2 Srichan Rd, Nai Mueang, Mueang Khon Kaen, Khon Kaen 40000'
		},
		{
			group: 'KIS',
			name: 'Central Silom Complex',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 191, B5 Floor, Silom Rd, Silom, Bang Rak, Bangkok 10500'
		},
		{
			group: 'KIS',
			name: 'Central Rama 2',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 160 Rama 2 Rd, Samae Dam, Bang Khun Thian, Bangkok 10150'
		},
		{
			group: 'KIS',
			name: 'Central Bangrak',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 1522 Charoen Krung Rd, Bang Rak, Bangkok 10500'
		},
		{
			group: 'KIS',
			name: 'Robinson Ratchaburi',
			province: 'Ratchaburi',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 265 Srisuriyawong Rd, Na Mueang, Mueang Ratchaburi, Ratchaburi 70000'
		},
		{
			group: 'KIS',
			name: 'Robinson Phitsanulok',
			province: 'Phitsanulok',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 9/85, Moo 5, Phlai Chumphon, Mueang Phitsanulok, Phitsanulok 65000'
		},
		{
			group: 'KIS',
			name: 'Robinson Ubon Ratchathani',
			province: 'Ubon Ratchathani',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 2312, Moo 7, Chaeramae, Mueang Ubon Ratchathani, Ubon Ratchathani 34000'
		},
		{
			group: 'KIS',
			name: 'Robinson Chachoengsao',
			province: 'Chachoengsao',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 910 Chachoengsao-Bang Pakong Rd, Na Mueang, Mueang Chachoengsao, Chachoengsao 24000'
		},
		{
			group: 'KIS',
			name: 'Robinson Buri Ram',
			province: 'Buri Ram',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 125, Moo 6, Krasang, Mueang Buri Ram, Buri Ram 31000'
		},
		{
			group: 'KIS',
			name: 'Robinson Chalong (Phuket)',
			province: 'Phuket',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 10/53, Moo 1, Chalong, Mueang Phuket, Phuket 83130'
		},
		{
			group: 'KIS',
			name: 'Robinson Rama 9',
			province: 'Bangkok',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 9/8-9 Ratchadaphisek Rd, Huai Khwang, Bangkok 10310'
		},
		{
			group: 'KIS',
			name: 'Central Phuket',
			province: 'Phuket',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 74-75, Wichit, Mueang Phuket, Phuket 83000'
		},
		{
			group: 'KIS',
			name: 'Robinson Surat Thani',
			province: 'Surat Thani',
			tel: '',
			url: 'https://www.facebook.com/kisbeautystore?locale=th_TH',
			address: 'No. 88, Moo 10, Wat Pradu, Mueang Surat Thani, Surat Thani 84000'
		},

				// --- กลุ่ม ROBINSON (16 สาขา) ---
				{
			group: 'ROBINSON',
			name: 'Nakhon Si Thammarat',
			province: 'Nakhon Si Thammarat',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '89/201 Phatthanakan Khu Khwang Rd, Khlang, Mueang Nakhon Si Thammarat, Nakhon Si Thammarat 80000'
		},
		{
			group: 'ROBINSON',
			name: 'Chon Buri',
			province: 'Chon Buri',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '55/90 Moo 1, Samet, Mueang Chon Buri, Chon Buri 20000'
		},
		{
			group: 'ROBINSON',
			name: 'Suphan Buri',
			province: 'Suphan Buri',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '449 Moo 5, Tha Rahat, Mueang Suphan Buri, Suphan Buri 72000'
		},
		{
			group: 'ROBINSON',
			name: 'Lampang',
			province: 'Lampang',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '319/1 Lampang-Ngao Highway Rd, Suan Dok, Mueang Lampang, Lampang 52100'
		},
		{
			group: 'ROBINSON',
			name: 'Kanchanaburi',
			province: 'Kanchanaburi',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '110 Moo 9, Pak Phraek, Mueang Kanchanaburi, Kanchanaburi 71000'
		},
		{
			group: 'ROBINSON',
			name: 'Sakon Nakhon',
			province: 'Sakon Nakhon',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '88/8 Nittayo Rd, That Choeng Chum, Mueang Sakon Nakhon, Sakon Nakhon 47000'
		},
		{
			group: 'ROBINSON',
			name: 'Surin',
			province: 'Surin',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '338 Moo 16, Salak Dai, Mueang Surin, Surin 32000'
		},
		{
			group: 'ROBINSON',
			name: 'Saraburi',
			province: 'Saraburi',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '99 Moo 7, Taling Chan, Mueang Saraburi, Saraburi 18000'
		},
		{
			group: 'ROBINSON',
			name: 'Roi Et',
			province: 'Roi Et',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '137 Moo 3, Dong Lan, Mueang Roi Et, Roi Et 45000'
		},
		{
			group: 'ROBINSON',
			name: 'Prachin Buri',
			province: 'Prachin Buri',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '72 Moo 3, Bang Boribun, Mueang Prachin Buri, Prachin Buri 25000'
		},
		{
			group: 'ROBINSON',
			name: 'Mukdahan',
			province: 'Mukdahan',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '99/11 Chayangkun Khor Rd, Mukdahan, Mueang Mukdahan, Mukdahan 49000'
		},
		{
			group: 'ROBINSON',
			name: 'Mae Sot (Tak)',
			province: 'Tak',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '99/115 Sai Asia Rd, Mae Sot, Mae Sot, Tak 63110'
		},
		{
			group: 'ROBINSON',
			name: 'Phetchaburi',
			province: 'Phetchaburi',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '162 Moo 1, Samoplue, Ban Lat, Phetchaburi 76150'
		},
		{
			group: 'ROBINSON',
			name: 'Kamphaeng Phet',
			province: 'Kamphaeng Phet',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '651/1 Charoen Rd, Nai Mueang, Mueang Kamphaeng Phet, Kamphaeng Phet 62000'
		},
		{
			group: 'ROBINSON',
			name: 'Chaiyaphum',
			province: 'Chaiyaphum',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '299/9 Moo 6, Nai Mueang, Mueang Chaiyaphum, Chaiyaphum 36000'
		},
		{
			group: 'ROBINSON',
			name: 'Trang',
			province: 'Trang',
			tel: '',
			url: 'https://www.facebook.com/RobinsonDepartmentStore/about?locale=th_TH',
			address: '138 Phatthalung Rd, Thap Thiang, Mueang Trang, Trang 92000'
		},

	];
	
const searchBtn = document.getElementById('searchBtn-en'); // ตรวจสอบ ID ให้ตรงกับ HTML
const clearBtn = document.getElementById('clearBtn-en');
const container = document.getElementById('storeContainer-en');
const summary = document.getElementById('resultSummary-en');

function openGoogleMap(address) {
    const query = encodeURIComponent(address);
    // เปลี่ยน URL ให้เป็นมาตรฐานของ Google Maps API
    window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
}

function performSearch() {
    const searchVal = document.getElementById('searchInput-en').value.trim();
    const groupVal = document.getElementById('groupFilter-en').value;
    const provinceVal = document.getElementById('provinceFilter-en').value;

    if (searchVal !== "" && searchVal.length < 3) {
        alert("Please enter at least 3 characters."); // เปลี่ยนเป็นอังกฤษให้เข้ากับธีม
        return;
    }

    const filtered = mockStores.filter(store => {
        const matchGroup = !groupVal || store.group === groupVal;
        const matchProvince = !provinceVal || store.province === provinceVal;
        // ปรับให้ค้นหาได้ทั้งตัวเล็กและตัวใหญ่
        const matchName = !searchVal || store.name.toLowerCase().includes(searchVal.toLowerCase());
        return matchGroup && matchProvince && matchName;
    });

    displayStores(filtered);
}

function displayStores(stores) {
    container.innerHTML = '';
    if (stores.length === 0) {
        container.innerHTML = '<div class="kma-finder-empty-state">No branches found.</div>';
        summary.innerText = '';
        return;
    }

    summary.innerText = `Total ${stores.length} branches`;
    stores.forEach(store => {
        const card = document.createElement('div');
        card.className = 'kma-finder-card';
        card.innerHTML = `
            <div class="kma-finder-card-header">
                <span class="kma-finder-tag">${store.group}</span>
                <a href="${store.url}" target="_blank" class="kma-finder-link">Visit Website</a>
            </div>
            <h3 class="kma-store-name">${store.name}</h3>
                    <div class="kma-store-info">
                        <span class="kma-icon">📍</span>
                        <span class="kma-text">${store.address}</span>
                    </div>
                    <div class="kma-store-info">
                        <span class="kma-icon">📞</span>
                        <span class="kma-text">${store.tel}</span>
                    </div>
            <button onclick="openGoogleMap('${store.address.replace(/'/g, "\\'")}')" class="kma-finder-map-btn">View Map</button>
        `;
        container.appendChild(card);
    });
}

searchBtn.addEventListener('click', performSearch);
clearBtn.addEventListener('click', () => {
    document.getElementById('searchInput-en').value = '';
    document.getElementById('groupFilter-en').value = '';
    document.getElementById('provinceFilter-en').value = '';
    container.innerHTML = '<div class="kma-finder-empty-state">Please enter information to start searching.</div>';
    summary.innerText = '';
});